import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';

const TimeInput = ({ time, setTime }) => {
  const langToggle = useLanguage;
  return (
    <div className="free__form-input__wrapper form-animate">
      <label className="free__form-label">
        {langToggle('Бажаний Час зв’язку:', 'Желаемое время связи:')}
      </label>
      <div className="free__form-input__time-wrapper">
        <div
          id="1"
          role="presentation"
          className={
            time === '09:00 - 13:00'
              ? 'free__form-input__time-item is-active'
              : 'free__form-input__time-item'
          }
          onClick={() => {
            setTime('09:00 - 13:00');
          }}
        >
          <input
            readOnly
            type="radio"
            className="free__form-input__time-input"
            value={time}
            name="09:00 - 13:00"
            checked={time === '09:00 - 13:00'}
          />
          <span className="free__form-input__time-title">09:00 - 13:00</span>
        </div>
        <div
          id="2"
          role="presentation"
          className={
            time === '14:00 - 18:00'
              ? 'free__form-input__time-item is-active'
              : 'free__form-input__time-item'
          }
          onClick={() => {
            setTime('14:00 - 18:00');
          }}
        >
          <input
            readOnly
            type="radio"
            className="free__form-input__time-input"
            value={time}
            name="14:00 - 18:00"
            checked={time === '14:00 - 18:00'}
          />
          <span className="free__form-input__time-title">14:00 - 18:00</span>
        </div>
      </div>
    </div>
  );
};

TimeInput.propTypes = {
  time: PropTypes.string,
  setTime: PropTypes.func,
};

export default TimeInput;
